<template>
  <b-modal
    id='ltcat-legal-interpretation-modal'
    size='lg'
    header-bg-variant='primary'
    header-text-variant='light'
    title='Personalize a sua experiência HO Fácil Web'
    ref='ltcat-legal-interpretation-modal'
    hide-footer
  >
    <form>
      <p style='text-align: justify'>
        Em 2022 a Fundacentro elaborou a nota técnica 01/2022/EARJ a qual orienta-se, segundo critério dos seus
        elaboradores, que não há agentes no grupo benzeno e seus compostos tóxicos dado que o benzeno por si só já seria
        um composto.
        Juridicamente esta orientação pode ser questionada e ampliada, de modo que nela também deveriam estar incluídos
        os hidrocarbonetos aromáticos puros (somente Carbono e Hidrogênio na composição com ao menos um anel aromático),
        pois esses fazem parte do grupo químico taxonômico Benzenoids (tradução literal: benzóides; correlação
        interpretativa jurídica com a nomenclatura do grupo 'benzeno e seus compostos tóxicos').
        Desde já deixamos claro quaisquer compostos diferentes do 71-43-2: Benzeno e que possam estar nessa
        interpretação jurídica têm características físicas, químicas e toxicológicas próprias e não devem ser analisados
        de maneira idêntica ao benzeno para fins de enquadramento legal no LTCAT.
        Dito isso, selecione a opção que você deseja ter informações e em seguida clique em salvar para prosseguir.
      </p>

      <div class='d-flex justify-content-center mb-3'>
        <b-button @click="change(INTERPRETACAO_JURIDICA)" :variant="legalInterpretation == INTERPRETACAO_JURIDICA ? 'primary' : 'outline-primary'" class='mr-3'>
          Interpretação jurídica
        </b-button>

        <b-button @click="change(FUNDACENTRO)" :variant="legalInterpretation == FUNDACENTRO ? 'primary' : 'outline-primary'">
          Fundacentro
        </b-button>
      </div>

      <b-input-group>
        <b-button variant='success' @click='save' block>
          <i class='fa fa-save mr-2'></i>Salvar
        </b-button>
      </b-input-group>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: 'LtcatLegalInterpretationModal',
  computed: {
    activities() {
      return [
        { value: `INTERPRETACAO_JURIDICA`, text: `Interpretação jurídica` },
        {
          value: `FUNDACENTRO`,
          text: `Fundacentro`
        }
      ]
    }
  },
  data() {
    return {
      legalInterpretation: null,
      FUNDACENTRO: 'FUNDACENTRO',
      INTERPRETACAO_JURIDICA: 'INTERPRETACAO_JURIDICA',
    }
  },
  methods: {
    change(value){
      this.legalInterpretation = value
    },

    save() {
      this.$emit(
        'save',
        Object.assign(this.agent, {
          legalInterpretation: this.legalInterpretation,
        })
      )
    },
  },
  props: ['agent', 'prevActivities'],
  watch: {
    agent() {
      this.legalInterpretation = this.agent.legalInterpretation
        ? this.agent.legalInterpretation
        : null
    }
  }
}
</script>
